import * as yup from 'yup';

export const newKitInventarioSchema = yup.object({
  nombre: yup.string().required('Campo Requerido'),
  bodega: yup.string().required('Campo Requerido'),
  ubicacion: yup.string().required('Campo Requerido'),
});